import { createI18n } from 'vue-i18n';
import { messages } from '../common/locales/messages';

const FALLBACK_LOCALE = 'en-US';
const DOCUMENT_LANGUAGE = document?.documentElement?.lang || FALLBACK_LOCALE;

const i18n = createI18n({
    legacy: false,
    locale: DOCUMENT_LANGUAGE,
    fallbackLocale: FALLBACK_LOCALE,
    messages,
});

export { i18n };
